export const acceptableLanguages = ["af", "en", "da", "nl", "fi", "fr", "de", "hu", "it", "mi", "nb", "nn", "pl", "pt", "es", "sv"];

export const spellcheckerRpcUrl = `${process.env.REACT_APP_TINYMCESPELLCHECKURL}/ephox-spelling`;

// Africaans (af) and Maori (mi) have differing LCID names for TinyMCE's spell-check plugin Hunspell dictionary 
// and what we use for the 2 char codes in acceptableLanguages, so this provides the proper mapping
export const lcidToHunspellLcid = {
    "af": "af_za",
    "mi": "mi_nz",
};